(() => {
  'use strict';
  function prepareBadgeData() {
    const marker = document.querySelector('[data-sc-image-badge-config]');
    if (!marker || marker.dataset.started) return;
    const currency = marker.dataset.currency;
    const products = new Map();
    try {
      const existing = JSON.parse(marker.dataset.products || '[]');
      if (Array.isArray(existing)) for (const product of existing) {
        if (product && typeof product.handle === 'string') products.set(product.handle, product);
      }
    } catch {}
    for (const node of document.querySelectorAll('[data-ll-badge-product]')) {
      try {
        const product = JSON.parse(node.dataset.llBadgeProduct);
        if (!product || product.currency !== currency || !Array.isArray(product.variants) ||
            product.variantCount !== product.variants.length || product.variantCount >= 250 ||
            !/^[a-zA-Z0-9_-]+$/.test(product.handle)) continue;
        if (products.size < 100 || products.has(product.handle)) products.set(product.handle, product);
      } catch {}
    }
    const data = JSON.stringify([...products.values()]);
    if (data.length <= 512000) {
      marker.dataset.products = data;
      marker.dataset.llSeededProducts = String(products.size);
    }
  }
  function preparePriceModule() {
    const marker = document.querySelector('[data-age-original-price-config]');
    if (!marker?.dataset.runtimeUrl) return;
    try {
      const url = new URL(marker.dataset.runtimeUrl, location.origin);
      if (url.protocol !== 'https:' || !url.pathname.endsWith('/original-price-display-runtime.js')) return;
      const script = [...document.scripts].find(node => {
        try { const src = new URL(node.src, location.origin); return src.origin === url.origin && src.pathname.endsWith('/original-price-display.js'); } catch { return false; }
      });
      if (!script || [...document.querySelectorAll('link[rel="modulepreload"]')].some(link => link.href === url.href)) return;
      const link = document.createElement('link');
      link.rel = 'modulepreload'; link.href = url.href; link.crossOrigin = 'anonymous';
      document.head.appendChild(link);
    } catch {}
  }
  function prepareBadgeModules() {
    if (!document.querySelector('[data-sc-image-badge-config]')) return;
    const versionPath = "/extensions/01a13643-04d2-77bc-9d6f-8f6207c59dfc/store-control-theme-compatibility-20261013-b1466a8a985e/assets/";
    const loader = [...document.scripts].find(script => {
      try { const url = new URL(script.src, location.origin); return url.origin === 'https://cdn.shopify.com' && url.pathname === versionPath + 'image-sale-badges.js'; } catch { return false; }
    });
    if (!loader) return;
    for (const filename of ["image-sale-badges-renderer-f738b2f3fc4bb126.js","image-sale-badges-page-data-c7ea32ca97519244.js","image-sale-badges-shared-fa567b0a5b617d66.js","image-sale-badges-targets-d5eabe24e0f91f3d.js"]) {
      const originalHref = new URL(filename, loader.src).href;
      let href = originalHref;
      try {
        const map = JSON.parse(document.querySelector('script[type="importmap"]').textContent);
        href = new URL(map.imports?.[originalHref] || originalHref, location.origin).href;
      } catch {}
      if ([...document.querySelectorAll('link[rel="modulepreload"]')].some(link => link.href === href)) continue;
      const link = document.createElement('link');
      link.rel = 'modulepreload'; link.href = href; link.crossOrigin = 'anonymous';
      document.head.appendChild(link);
    }
  }
  function deferSeoHelper() {
    const placeholder = document.querySelector('script[data-ll-idle-src]');
    if (!placeholder) return;
    let scheduled = false;
    const load = () => {
      if (!placeholder.isConnected) return;
      const script = document.createElement('script');
      for (const attribute of placeholder.attributes) {
        if (!['type', 'data-ll-idle-src'].includes(attribute.name)) script.setAttribute(attribute.name, attribute.value);
      }
      script.type = 'text/javascript';
      script.src = placeholder.dataset.llIdleSrc;
      script.async = true;
      placeholder.replaceWith(script);
    };
    const schedule = () => {
      if (scheduled) return;
      scheduled = true;
      window.removeEventListener('load', schedule);
      if ('requestIdleCallback' in window) window.requestIdleCallback(load, {timeout: 1500});
      else window.setTimeout(load, 100);
    };
    if (document.readyState === 'complete') schedule();
    else {
      window.addEventListener('load', schedule, {once: true});
      window.setTimeout(schedule, 4000);
    }
  }
  prepareBadgeData();
  preparePriceModule();
  prepareBadgeModules();
  deferSeoHelper();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => {
    prepareBadgeData(); preparePriceModule(); prepareBadgeModules();
  }, {once:true});
})();
